import React, { useEffect, useState } from 'react'
import { Get_Cart_List, Remove_Cart_List, Shipping_Address } from '../../../api/category_product/Category_Product';
import { User_Authentication } from '../../../user_authentication/User_Authentication';
import { IMG_BASE_URL } from '../../../config/Config';
import Loader from '../../../loader/Loader';
import { toast } from "react-toastify";
import { HeartIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { HeartIcon as HeartIconSolid } from '@heroicons/react/24/solid';

import { Link, useNavigate } from 'react-router-dom';
import { fetchCartList } from '../../../redux/actions/cartActions';
import { useDispatch, useSelector } from 'react-redux';

const Cart_Sidebar = (props) => {
    const [isOpen, setIsOpen] = useState(true);
    const dispatch = useDispatch()
    const [is_loading, set_Is_Loading] = useState(false)
    const { cartlist, shippingAmount, isloading, error } = useSelector((state) => state.cartlist);

    const [cart_list, set_Cart_List] = useState(cartlist || []);
    const navigate = useNavigate();
    const [address_list, set_Address_list] = useState([]);
    const [active_shiping_address, set_Active_Shiping_Address] = useState(null);


    const [finalshippingAmount, set_Final_ShippingAmount] = useState(0)
    // const [selectedCartIds, setSelectedCartIds] = useState([]);
    const { toggleOffcanvas } = props
    // useEffect(() => {
    //     const Handle_Get_Cart_List = async () => {
    //         try {
    //             const token = User_Authentication();
    //             if (!token) {
    //                 set_Is_Loading(false);
    //                 throw new Error("User token not found");
    //             }
    //             const response = await Get_Cart_List({ Authorization: `Bearer ${token}` })
    //             if (response?.response?.status == 401) {
    //                 localStorage.removeItem("user_token");
    //                 localStorage.removeItem("user_is_active");
    //                 toast("Token Expired. Please Login Again.");
    //                 navigate("/");
    //             }
    //             set_Cart_List(response?.data?.data?.cartlist)
    //         } catch (error) {
    //         }
    //     }
    //     Handle_Get_Cart_List();
    // }, [])

    // useEffect(() => {
    //     if (!Array.isArray(cartlist) || cartlist?.length === 0) return;
    //     if (selectedCartIds?.length === 0) {
    //         const allIds = cartlist?.map(item => item.id);
    //         setSelectedCartIds(allIds);
    //     }

    // }, [cartlist]);

    useEffect(() => {
        set_Active_Shiping_Address(address_list?.[0]?.id ?? null);
    }, [address_list]);

    useEffect(() => {
        const Handle_Get_Address_List = async () => {
            // set_Is_Loading(true)
            try {
                const token = User_Authentication();
                if (!token) {
                    set_Is_Loading(false);
                    throw new Error("User token not found");
                }
                const response = await Shipping_Address({ Authorization: `Bearer ${token}` })
                if (response?.data?.status == "200") {
                    set_Address_list(response?.data?.data?.shipping_addresses)

                    // set_Is_Loading(false)
                }
                else if (response?.response?.data?.status == "500") {
                    // set_Is_Loading(false)
                }
            } catch (error) {
                console.error(error)
                // set_Is_Loading(false)
            }
        }
        Handle_Get_Address_List();
    }, [])


    // const selectedCartItems = cart_list?.filter(item =>
    //     selectedCartIds.includes(item.id)
    // );
    const cartTotalAmount = cart_list
        ?.filter(item => item?.product?.current_stock > 0)
        ?.reduce((total, item) => {

            const unitPrice = item.total_price / item.qty;
            return total + (unitPrice * item.qty);
        }, 0) || 0;

    const gstTotalAmount = cart_list?.reduce((total, item) => {
        const unitgstAmount = Number(item.gst_amount)
        return total + unitgstAmount;
    }, 0) || 0;

    const total_Coupon_Amount = cart_list?.reduce((total, item) => {
        const unitCouponAmount = Number(item.total_coupon_amount)
        return total + unitCouponAmount;
    }, 0) || 0;


    const afterDiscountPrice = cartTotalAmount;

    const getShippingAmount = (shippingData, cartTotalAmount) => {

        if (!Array.isArray(shippingData)) return 0;

        const matched = shippingData.find(rule =>
            cartTotalAmount >= rule.min_amount && cartTotalAmount <= rule.max_amount
        );

        return matched ? matched.amount : 0;
    };

    useEffect(() => {
        if (shippingAmount?.length > 0 && cartTotalAmount > 0) {
            const fetchshippingAmount = getShippingAmount(shippingAmount, cartTotalAmount);
            set_Final_ShippingAmount(fetchshippingAmount)
        }
        else {
            set_Final_ShippingAmount(0);
        }
    }, [shippingAmount, cartTotalAmount]);

    useEffect(() => {
        set_Cart_List(cartlist);
    }, [cartlist]);

    useEffect(() => {
        const result = dispatch(fetchCartList());
    }, [dispatch]);

    // <------- Remove Cart List ----------->
    const Handle_Remove_Cart_List = async (cart_id) => {
        try {
            const token = User_Authentication();
            if (!token) {
                set_Is_Loading(false);
                throw new Error("User token not found");
            }
            const data = {
                cart_id: cart_id
            }
            const response = await Remove_Cart_List(data, { Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                toast.success("Remove item from cart")
                set_Cart_List((prevList) => prevList?.filter(item => item.id !== cart_id));
                window.location.reload()
            }
        } catch (error) {
            console.error(error)
        }
    }

    // const handleSelectCartItem = (cartId) => {
    //     setSelectedCartIds((prev) =>
    //         prev.includes(cartId)
    //             ? prev.filter(id => id !== cartId)
    //             : [...prev, cartId]
    //     );
    // };
    // Calculate subtotal using reduce()
    const subtotal = cart_list?.reduce((total, cart_list_result) => {
        return total + (cart_list_result?.total_price || 0);
    }, 0);

    const showLoader = isloading || is_loading;

    return (
        <div>
            {
                showLoader ? (
                    <Loader />
                ) : (
                    <>
                        {/* Overlay */}
                        <div
                            className={`fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
                            onClick={toggleOffcanvas}></div>
                        {/* Offcanvas Sidebar */}
                        <div
                            className={`fixed top-0 right-0 w-96 h-full bg-white shadow-lg z-50 p-0 transform transition-transform duration-300 ease-in-out  ${isOpen ? "translate-x-0" : "translate-x-full"}`}>
                            <div className="flex flex-col ">
                                <div className='flex justify-between p-4 items-center'>
                                    <h2 className="text-sm font-semibold text-black">My Cart</h2>
                                    <button
                                        onClick={toggleOffcanvas}
                                        className="self-end text-gray-600 hover:text-gray-900">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-6 w-6"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor">
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                                {/* Offcanvas Content */}
                                {
                                    cart_list?.length > 0 ? (
                                        <>
                                            <ul className="gi-cart-pro-items bg-[#F6F6F6] p-[10px] overflow-y-auto max-h-[calc(100vh-170px)]">
                                                {
                                                    cart_list?.map((cart_list_result) => {
                                                        return (
                                                            <li
                                                                className="relative mb-[15px] p-[15px] flex  overflow-hidden bg-white rounded-[5px]">
                                                                {/* <input
                                                                    type="checkbox"
                                                                    checked={selectedCartIds.includes(cart_list_result?.id)}
                                                                    onChange={() => handleSelectCartItem(cart_list_result?.id)}
                                                                    className="absolute h-5 w-5 cursor-pointer"
                                                                /> */}
                                                                <Link to="/cart" className="gi-pro-img flex grow-[1] basis-[20%] items-center"><img
                                                                    src={`${IMG_BASE_URL}${cart_list_result?.product?.single_image?.image_url}`} className="w-full" alt="product" /></Link>
                                                                <div className="gi-pro-content relative grow-[1] basis-[70%] pl-[15px] overflow-hidden">
                                                                    <Link to='/cart' className="cart-pro-title w-full font-semibold pr-[30px] text-gray-900 whitespace-normal text-ellipsis block text-[12px] leading-[18px]" onClick={toggleOffcanvas}>{cart_list_result?.product?.name}</Link>
                                                                    <span className="cart-price text-[#000] font-bold text-[12px] uppercase block mt-[5px]">Qty: {cart_list_result?.qty}</span>
                                                                    <span className="cart-price text-[#000] font-bold text-[12px] uppercase block mt-[5px]">₹ {cart_list_result?.total_price}</span>

                                                                    <a onClick={() => Handle_Remove_Cart_List(cart_list_result?.id)}
                                                                        className="remove leading-[15px] absolute bottom-[0] right-[0] pl-[10px] text-[#9F2225] text-[12px] uppercase cursor-pointer"><XMarkIcon className="w-5 h-5 text-gray-500]" /></a>
                                                                </div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>

                                        </>
                                    ) : (
                                        <>
                                            <div className="flex items-center justify-center h-screen">
                                                <h3 className="text-center text-[#777] text-[12px]">
                                                    Your cart is currently empty.
                                                </h3>
                                            </div>
                                        </>
                                    )
                                }
                                <div className="cart_btn flex p-[3px] w-full justify-between mb-[20px]">
                                    <div className="gi-cart-bottom bg-white w-full fixed bottom-0 p-3 items-center justify-between">
                                        {cart_list?.length > 0 && (
                                            <div
                                                className="cart-sub-total flex w-full flex-wrap justify-between pt-[15px] pb-[8px]">
                                                <table className="table cart-table w-full">
                                                    <tbody className="mt-[10px]">
                                                        <tr>
                                                            <td className="text-left font-medium text-[12px] text-gray-800 p-[6px]">Subtotal :</td>
                                                            <td className="text-right font-bold text-[12px] text-gray-800 p-[6px]">
                                                                ₹ {cartTotalAmount}/-
                                                            </td>
                                                        </tr>

                                                        {/* {total_Coupon_Amount > 0 && (
                                                        <tr>
                                                            <td className="text-left font-medium text-[12px] text-gray-800 p-[6px]">Coupon Discount :</td>
                                                            <td className="text-right font-bold text-[12px] text-gray-800 p-[6px]">
                                                                ₹ {total_Coupon_Amount || 0.00}/-
                                                            </td>
                                                        </tr>
                                                    )} */}

                                                        {/* {finalshippingAmount > 0 && (
                                                        <tr>
                                                            <td className="text-left font-medium text-[12px] text-gray-800 p-[6px]">Shipping :</td>
                                                            <td className="text-right font-bold text-[12px] text-gray-800 p-[6px]">
                                                                ₹ {finalshippingAmount || 0.00}/-
                                                            </td>
                                                        </tr>
                                                    )} */}
                                                        {/* 
                                                    {gstTotalAmount > 0 && (
                                                        <tr>
                                                            <td className="text-left font-medium text-[12px] text-gray-800 p-[6px]">Tax :</td>
                                                            <td className="text-right font-bold text-[12px] text-gray-800 p-[6px]">
                                                                ₹ {gstTotalAmount || 0.00}/-
                                                            </td>
                                                        </tr>
                                                    )} */}

                                                        {/* <tr>
                                                        <td className="text-left font-medium text-[12px] text-gray-800 p-[6px]">Order Total :</td>
                                                        <td className="text-right font-bold text-[12px] text-gray-800 p-[6px]">
                                                            ₹ {afterDiscountPrice + finalshippingAmount + gstTotalAmount - total_Coupon_Amount}/-
                                                        </td>
                                                    </tr> */}

                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        <div className="grid grid-cols-2 gap-3">
                                            <Link to="/cart" onClick={() => setIsOpen(false)}
                                                className="w-full text-[13px] uppercase text-center px-6 py-2.5 inline-block border border-gray-900 text-white bg-black hover:text-white hover:border-gray-900 hover:bg-gray-900">View
                                                Cart</Link>
                                            {cart_list?.length > 0 && (
                                                <button type='button' onClick={() => {
                                                    // if (selectedCartIds.length === 0) {
                                                    //     toast.error("Please select at least one item");
                                                    //     return;
                                                    // }
                                                    if (!active_shiping_address) {
                                                        toast("Please add a shipping address before proceeding.");
                                                        return;
                                                    }
                                                    navigate("/order-place", {
                                                        state: {
                                                            cart_list: cart_list,
                                                            // coupanResponse: coupanResponse,
                                                            activeShippingAddress: active_shiping_address,
                                                            finalshippingAmount: finalshippingAmount,
                                                            gstTotalAmount: gstTotalAmount,
                                                            total_Coupon_Amount: total_Coupon_Amount
                                                        }
                                                    });
                                                }}
                                                    className="w-full text-[13px] uppercase text-center px-6 py-2.5 inline-block border border-gray-900 text-gray-700 hover:text-white hover:border-gray-900 hover:bg-gray-900">Checkout</button>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        </div >
    )
}

export default Cart_Sidebar